<template>
<div>
  <template v-if="consumerName">
    <Details v-if="!isLmrConsumer"/>
    <div v-if="$store.state.consumerGroup == 'ebra'">
      <div class="marker-details">
        <h3 v-if="showVideos" class="highlight">{{ $tc('records.video', 2) }}</h3>
        <h3 v-if="showImages" class="highlight">{{ $t('menu.images') }}</h3>
      </div>
    </div>
    <div>
      <div class="records-information row">
        <div class="col-md-12">
          <p v-if="records.length && !isLmrConsumer">
            <span class="highlight">
              {{records.length}} {{ $tc('records.video', records.length >= 2 ? 2 : 1) }}
            </span>
            {{ $tc('records.has_been_recorded', records.length >= 2 ? 2 : 1) }}
            <span v-if="diversityTree">
              <br />
              <a href="#" :title="$t('records.show_dendrogram')" @click.prevent="showTree = !showTree">
                <img
                  style="height: 16px; cursor: pointer; opacity:0.7;"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII="
                  alt="dendrogram"
                />
              </a>
            </span>
          </p>
        </div>
      <transition name="fade">
        <dendrogram :root="diversityTree" v-if="showTree" class="dendrogram"></dendrogram>
      </transition>
      </div>
      <div class="records">
        <transition name="fade" mode="out-in">
          <div v-if="newVideosCount > 0" class="alert new-record-avaible">
            <span class="badge">{{ newVideosCount }}</span>
            {{ $tc('records.new_available', newVideosCount >= 2 ? 2 : 1) }}
            <a href="#" @click.prevent.stop="swapInNewRecords()">{{ $tc('records.click_here_to_refresh') }}</a>
          </div>
        </transition>
        <div class="row" v-if="$root.$children[0].$data.clientId != 'digiteka'">
          <lmr-city-report-filter
            v-if="!$store.state.editorConsumers[0]"
            class="col-md-6"
            v-model="recordFilters.lmr_cities"
            @change="handleLmrCitySelected"
          />
          <editor-consumer-filter
            v-else
            class="col-md-6"
            v-model="recordFilters.editor_consumers"
            @change="handleEditorConsumerSelected"
          />
          <marker-tags-selector
            ref="tagsFilter"
            class="col-md-6"
            :markerId="markerId"
            @tags-selected="handleTagsSelected"
          />
        </div>
        <div class="row" v-else>
          <lmr-city-report-filter
            class="col-md-12"
            v-model="recordFilters.lmr_cities"
            @change="handleLmrCitySelected"
          />
        </div>
        <div class="row">
          <v-autocomplete
            ref="filterByAuthor"
            class="col-md-6 order_list"
            v-model="recordFilters.user"
            :items="filtersAuthors"
            :loading="isLoadingAuthors"
            :search-input.sync="searchFilteredUser"
            hide-no-data
            hide-selected
            item-text="autocomplete_full_name"
            item-value="pk"
            :placeholder="$t('user.filter.filter_by_user')"
            return-object
            outline
            clearable
            single-line
            @input="fetchRecords"
          ></v-autocomplete>
          <v-select
            class="col-md-6 right order_list"
            :placeholder="$t('Ordering')"
            :items="itemsOrdering"
            flat
            outline
            single-line
            v-model="recordOrdering"
            @input="fetchRecords"
          ></v-select>
        </div>
        <div class="row">
          <lmr-category-filter
            class="col-md-6"
            v-if="isLmrConsumer"
            v-model="recordFilters.lmr_category"
            @change="fetchRecords"
          />
          <v-select v-if="consumer_group === 'ebra'"
            class="col-md-6 right order_list"
            :placeholder="$t('departments.filter_by_department')"
            :items="departments"
            flat
            outline
            single-line
            v-model="department"
            @input="fetchRecords"
          ></v-select>
          <sdk-filter
            v-if="consumer_group === 'rossel'"
            v-model="recordFilters.sdk_record"
            @change="fetchRecords"
          />
        </div>


        <!-- <inappropriate-filter
          v-model="recordFilters.inappropriate"
          @change="fetchRecords('VIDEO')"
        /> -->
        <v-tabs v-model="activeTabIndex" fixed-tabs slider-color="#ff2d55">
          <v-tab>
            {{ $t('new') }} <span v-if="newTabRecordsCount" class="badge">{{ newTabRecordsCount }}</span>
          </v-tab>
          <v-tab id="approved_tab">{{ $t('approved') }}</v-tab>
          <v-tab>{{ $t('deleted') }}</v-tab>
        </v-tabs>
        <div v-if="activeTabIndex === recordTabs.new && isLmrConsumer" id="select-mode-btn-wrapper">
          <button
            v-if="records.length"
            id="select-mode-btn"
            class="btn btn-default highlight mr-1"
            :class="{active: approveMode}"department
            @click="toggleApproveMode"
          >{{ $t('approve').toUpperCase() }}</button>
          <button
            v-if="showVideos && records.length > 1"
            id="merge-mode-btn"
            class="btn btn-default highlight"
            :class="{active: mergeMode}"
            @click="toggleMergeMode"
          >{{ $t('merge').toUpperCase() }}</button>

<v-spacer></v-spacer>
<template>
<!--  <button-->
<!--    v-if="records.length"-->
<!--    id="download-mode-btn"-->
<!--    class="btn btn-default mr-1 highlight"-->
<!--    :class="{active: downloadMode}"-->
<!--    @click.stop="toggleDownloadMode"-->
<!--  >-->
<!--    {{ $t('upload_video.download_video_title').toUpperCase() }}-->
<!--  </button>-->
  <button
    id="add-video-mode-btn"
    class="btn btn-default highlight right"
    @click.stop="dialog = true"
    v-if="!videoFileUploading && !showImages"
  >
    {{ $t('upload_video.upload_video_title').toUpperCase() }}
  </button>
  <v-dialog
    v-model="dialog"
    persistent max-width="600px"
  >
    <v-card style="padding: 20px">
      <v-card-title>
        <span class="headline">{{ $t('upload_video.upload_video_title') }}</span>
      </v-card-title>
      <v-card-text v-if="videoFileUploading">
        <v-container  style="padding: 0">
          <div
            class="subtitle-1 text-center"
            cols="12"
          >
            {{ $t('upload_video.upload_progress') }} ({{ bufferVideoUploading }}%)
          </div>
            <v-progress-linear
              v-model="bufferVideoUploading"
              :buffer-value="100"
              color="#ff2d55"
              bufferVideoUploading
              height="6"
            ></v-progress-linear>
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        <div v-if="!uploadingVideoFile">
          <div
            :class="['dropZone', dragging ? 'dropZone-over' : '']"  
            @dragenter="dragging = true"
            @dragleave="dragging = false"
          >
            <div class="dropZone-info" @drag="onChange">
              <span class="fa fa-cloud-upload dropZone-title"></span>
              <span class="dropZone-title">{{ $t('upload_video.drop_file_or_click')}}</span>
              <div class="dropZone-upload-limit-info">
                <div>{{ $t('upload_video.support_file') }}</div>
                <div>{{ $t('upload_video.max_file_size')}}: 500 MB</div>
                <div v-if="uploadVideoFormHasErrors">{{ $t('upload_video.you_must_add_video_file') }}</div>
              </div>
            </div>
            <input type="file" accept="video/*" @change="onChange">
          </div>
        </div>
        <div v-else class="dropZone-uploaded">
          <div class="dropZone-uploaded-info">
            <span class="dropZone-title">{{ $t('upload_video.checked') }}</span>
             <div class="uploadedFile-info">
              <div>{{ $t('upload_video.file_name') }}: {{ uploadingVideoFile.name }}</div>
              <div>{{ $t('upload_video.file_size') }}: {{ (uploadingVideoFile.size / 1000000).toFixed(2) }} MB</div>
              <div>{{ $t('upload_video.extension') }}: {{ extension }}</div>
            </div>
            <button type="button" class="btn btn-primary removeFile" @click="removeFile">{{ $t('upload_video.remove_file') }}</button>
          </div>
        </div>
        <div>
          <v-radio-group
            v-model="typeVideoUpload"
            row
            ref="typeVideoUpload"
            :rules="[() => !!typeVideoUpload || $t('upload_video.field_is_required')]"
          >
            <v-radio
              color="rgb(255, 45, 85)"
              v-for="item in videoUploadTypes"
              :key="item.value"
              :label="videoUploadTypeName(item.value)"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
          <v-autocomplete
            ref="uploadVideoAuthor"
            v-model="uploadVideoAuthor"
            :items="entriesAuthors"
            :rules="[() => !!uploadVideoAuthor || $t('upload_video.field_is_required')]"
            :loading="isLoadingAuthors"
            :search-input.sync="search"
            color="#ff2d55"
            hide-no-data
            hide-selected
            item-text="autocomplete_full_name"
            item-value="pk"
            :placeholder="$t('upload_video.start_typing')"
            return-object
          ></v-autocomplete>
          <v-text-field
            ref="titleVideoUpload"
            :rules="[() => {
              if (!titleVideoUpload) return $t('upload_video.field_is_required')
              if (titleVideoUpload.length > 100) return $t('upload_video.field_is_too_big')
              return true
            }]"
            color="#ff2d55"
            v-model="titleVideoUpload"
            :counter="100"
            :label="$t('upload_video.title')"
            required
          ></v-text-field>
          <v-textarea
            v-if="consumerHasDescriptionField"
            ref="descriptionVideoUpload"
            :rules="[() => !!descriptionVideoUpload || $t('upload_video.field_is_required')]"
            color="#ff2d55"
            v-model="descriptionVideoUpload"
            name="input-7-1"
            :label="$t('upload_video.description')"
            value=""
          ></v-textarea>
          <v-text-field
            v-if="isEbraConsumer"
            ref="recommendedPublicationDate"
            color="#ff2d55"
            v-model="recommendedPublicationDate"
            name="input-7-2"
            value=""
            :label="$t('upload_video.recommended_publication_date')"
            :counter="25"
          ></v-text-field>
          <v-text-field
            v-if="isEbraConsumer"
            ref="commentFromAuthor"
            color="#ff2d55"
            v-model="commentFromAuthor"
            name="input-7-3"
            value=""
            :label="$t('upload_video.comment_from_author')"
            :counter="100"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions style="padding: 16px">
        <v-spacer></v-spacer>
        <v-btn color="#ff2d55" outline @click="dialog = false">{{ $t('upload_video.close') }}</v-btn>
        <v-btn 
          v-if="!videoFileUploading" 
          :disabled="uploadFormInvalid"
          color="#ff2d55" 
          outline 
          @click="uploadData"
        >
          {{ $t('upload_video.upload') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

        </div>

        <div v-show="loading && !records.length" class="loading-indicator center-block"></div>
        <p v-if="!records.length && !loading" class="empty">
          {{ $t("records.none_available") }}
        </p>
        <!-- Refresh overlay: records fetches are silent (no global Pace bar) and
             a filter/ordering change does not empty the list, so the centered
             spinner above (empty-state only) never fires. Instead, keep the
             current list visible but dimmed and float a spinner over it while
             loading, so the in-flight refetch is clearly signalled. -->
        <div class="records-list-wrap">
          <records-list
            :class="{ 'records--refreshing': loading && records.length }"
            :records="records"
            :marker-id="markerId"
            :selectedRecords="selectedRecords"
            :showSelectIndex="mergeMode"
            @delete-record="handleRecordDelete"
            @restore-record="handleRecordRestore"
            @mark-record-relevance="markRecordRelevance"
            @clicked-record="recordClicked"
            :isChoosingMode="approveMode || mergeMode || downloadMode"
          />
          <div v-show="loading && records.length" class="records-refresh-overlay">
            <v-progress-circular :indeterminate="true" color="#ff2d55" :size="48" :width="4"></v-progress-circular>
          </div>
        </div>
        <div v-show="amountOfPages > 1">
          <v-pagination
            v-model="currentPage"
            @input="records = []; fetchRecords()"
            :length="amountOfPages"
            :total-visible="10"
          ></v-pagination>
        </div>
        <div v-if="mergeMode || approveMode || downloadMode" style="margin-bottom: 100px"></div>
      </div>

      <div v-if="approveMode" class="select-mode-bar">
        <div class="container">
          <button
            v-if="!showImages"
            class="btn btn-info left"
            @click="downloadRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            v-if="showImages"
            class="btn btn-info left"
            @click="downloadRecordsZip"
            :disabled="!selectedRecords.length"
          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            class="btn btn-danger left"
            @click="toggleApproveMode"
            :disabled="false"
          >{{ $t('cancel').toUpperCase() }}</button>
          <button
            class="btn btn-danger"
            @click="rejectRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('reject').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            v-if="!showImages"
            class="btn btn-success"
            @click="approveRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('records.approve').toUpperCase() }} ({{ selectedRecords.length }})</button>

        </div>
      </div>

      <div v-if="mergeMode" class="select-mode-bar">
        <div class="container">
          <button
            class="btn btn-danger left"
            @click="toggleMergeMode"
          >{{ $t('cancel').toUpperCase() }}</button>
          <button
            class="btn btn-success"
            @click="setMergeRecordTitle(false)"
            :disabled="!(selectedRecords.length > 1)"
          >{{ $t('merge').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            class="btn btn-success"
            @click="setMergeRecordTitle(true)"
            :disabled="!(selectedRecords.length > 1)"
          >{{ $t('merge_and_approve').toUpperCase() }} ({{ selectedRecords.length }})</button>
        </div>
      </div>

<!--      <div v-if="downloadMode" class="select-mode-bar">-->
<!--        <div class="container">-->
<!--          <button-->
<!--            class="btn btn-danger"-->
<!--            @click="toggleDownloadMode"-->
<!--          >{{ $t('cancel').toUpperCase() }}</button>-->
<!--          <button-->
<!--            class="btn btn-success"-->
<!--            @click="downloadRecords"-->
<!--            :disabled="!selectedRecords.length"-->
<!--          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>-->
<!--        </div>-->
<!--      </div>-->

      <record-details
        :record="selectedRecord"
        v-if="selectedRecord"
        @clicked-similar-record="showRecordDetails"
        @close="selectedRecord = null"
        @cut-started="setCutIcon"
      >
      </record-details>

      <template v-if="relatedRecords.length > 0">
        <div class="records-information related-records row">
          <div class="col-md-12">
            <h3>{{ $tc('records.related_streams_title') }}</h3>
            <p class="help-block">
              <em>
                {{ $tc('records.related_streams_help') }}
              </em>
            </p>
          </div>
        </div>
        <div class="records related-records row">
          <!-- Marker related VODs list: -->
          <records-list :records="relatedRecords" :read-only="true"></records-list>
        </div>
      </template>

      <modal
        v-if="showPremergeModal"
        :show="showPremergeModal"
        @ok="mergeRecords"
        @hide="toggleMergeMode"
        :okBtnText="$t('records.start_merge')"
        :disableOkBtn="disableMergeOkButton"
      >
      <v-textarea
                ref="mergeData.title"
                :rules="[() => !!mergeData.title || $t('upload_video.field_is_required')]"
                color="#ff2d55"
                v-model="mergeData.title"
                :counter="100"
                :label="$t('upload_video.title')"
                required
                rows="8"
                class="form-row form-control"
              ></v-textarea>
        <template slot="body">
          <div class="edit-record-notes form-group">
            <div v-if="consumerHasDescriptionField" class="form-row">
              <input name="record-title" rows="8" cols="80" class="form-control"
               v-model="mergeData.title"
              />
              <textarea name="record-description" rows="8" cols="80" class="form-control"
               v-model="mergeData.description"
              ></textarea>
            </div>
            <div v-else>
              <v-textarea
                ref="mergeData.title"
                :rules="[
                  () => {
                  if (!mergeData.title) {
                    disableMergeOkButton = true;
                    return $t('upload_video.field_is_required') 
                  } else if (mergeData.title.length > 100) {
                    disableMergeOkButton = true;
                    return $t('upload_video.field_is_too_big')
                  }
                  disableMergeOkButton = false;
                  return true                
                  }
                ]"
                color="#ff2d55"
                v-model="mergeData.title"
                :counter=100
                :label="$t('upload_video.title')"
                required
                style="width:600px;"
              ></v-textarea>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </template>
</div>
</template>

<script>

import Details from './Details.vue'
import Dendrogram from '../marker/MarkerDendrogram.vue'
import events from '../../services/events'
import MarkerTagsSelector from '../marker/record/MarkerTagsSelector'
import InappropriateFilter from '../marker/record/InappropriateFilter'
import RecordDetails from '../marker/record/RecordDetails.vue'
import RecordRepository from '../../repositories/RecordRepository.js'
import RecordsList from '../marker/record/RecordsList.vue'
import LmrCategoryFilter from '../marker/record/LmrCategoryFilter'
import LmrCityReportFilter from '../marker/record/LmrCityReportFilter'
import SdkFilter from '../marker/record/SdkFilter'
import Modal from '@/components/generic/Modal.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import auth from '../../services/auth'
import http from '../../services/http'
import UserRepository from '../../repositories/UserRepository'
import EditorConsumerFilter from '../marker/record/EditorConsumerFilter'
import debounce from 'lodash.debounce'

export default {
  components: {
    Details,
    RecordsList,
    Dendrogram,
    MarkerTagsSelector,
    InappropriateFilter,
    RecordDetails,
    LmrCategoryFilter,
    LmrCityReportFilter,
    SdkFilter,
    Modal,
    EditorConsumerFilter,
  },
  props: [
    'markerId',
    'recordType',
  ],
  data: function () {
    return {
      records: [],
      newVideosCount: 0,
      relatedRecords: [], // deprecated
      diversityTree: null, // deprecated
      showTree: false, // deprecated
      timer: '',
      processStatusInterval: null,
      processStatusPollFailed: false, // true after a background status poll fails; reset on next success
      mergeRecordTimeout: null,
      loading: true,
      recordFilters: {
        tags: [],
        // inappropriate: 'hide',
        // special filters for LMR consumer
        lmr_category: '',
        sdk_record: '',
        lmr_cities: [],
        user: null,
        editor_consumers: []
      },
      recordOrdering: '',
      itemsOrdering: [],
      recordTabs: {
        new: 0,
        approved: 1,
        deleted: 2,
      },
      activeTabIndex: null,
      newTabRecordsCount: 0,
      pageSize: 20,
      currentPage: 1,
      selectedRecord: null,
      approveMode: false,
      mergeMode: false,
      downloadMode: false,
      selectedRecords: [], // used for select/merge mode
      pageLoadDate: null, // used for checking that new records have appreared
      showPremergeModal: false,
      mergeData: {
        approve: false,
        title: '',
        description: '',
      },
      dialog: false,
      uploadingVideoFile: '',
      dragging: false,
      titleVideoUpload: '',
      recommendedPublicationDate: '',
      commentFromAuthor: '',
      authorVideoUpload: '',
      descriptionVideoUpload: '',
      typeVideoUpload: 'sport',
      uploadVideoFormHasErrors: false,
      videoFileUploading: false,
      videoUploadTypes: [
        { value: 'sport' },
        { value: 'general' }
      ],
      isLoadingAuthors: false,
      uploadVideoAuthor: null,
      search: null,
      searchFilteredUser: null,
      filtersAuthors: [],
      entriesAuthors: [],
      bufferVideoUploading: 0,
      user_groups: [],
      consumer_group: '',
      departments: [],
      department: '',
      disableMergeOkButton: false,
    }
  },
  beforeMount () {
    this.activeTabIndex = this.tabIndexFromRoute()
  },
  mounted () {
    this.fetchRecords()
    this.setPageLoadDate()
    this.setupInterval()
    this.processStatusInterval = setInterval(
      this.updateRecordProcessStatus, 10000
    )
    // this.fetchRelatedRecords()
    // this.fetchRecordsDiversity()
    UserRepository.fetchMyUserDetails().then(data => {
      this.user_groups = data.user_group_list
      this.consumer_group = data.consumer_group
      if (data.consumer_group === 'ebra') {
        this.videoUploadTypes.push({value: 'magazine'})
      }
      if (this.$store.state.consumerName === 'lng') {
        this.videoUploadTypes.push({value: 'faits_divers'})
      }
      if (data.consumer_group === 'ebra') {
        this.departments = data.departments.map((department) => ({text: department.name, value: department.slug}))
        var d = [
          {text: this.$t('departments.all'), value: '0'},
        //  {text: 'Without Department', value: 'None'}
        ]
        this.departments = d.concat(this.departments)
      }
    })
  },

  computed: {
    ...mapGetters(['isLmrConsumer', 'isEbraConsumer']),
    ...mapState(['consumerName', 'consumerHasDescriptionField']),
    showVideos () {
      return this.recordType === 'VIDEO'
    },
    showImages () {
      return this.recordType === 'IMAGE'
    },
    amountOfPages () {
      return Math.ceil(this.records.count / this.pageSize) || 1
    },
    activeTabName () {
      return Object.entries(this.recordTabs)
        .find((name, index) => index === this.activeTabIndex)[0]
    },
    extension () {
      return (this.uploadingVideoFile) ? this.uploadingVideoFile.name.split('.').pop() : ''
    },
    // Whether the upload modal's OK button must be disabled. Derived from the
    // actual form fields instead of mutating flags from the template / :rules
    // during render (which was a side-effect-in-render anti-pattern).
    uploadFormInvalid () {
      return !this.uploadingVideoFile ||
        !this.uploadVideoAuthor ||
        !this.titleVideoUpload ||
        this.titleVideoUpload.length > 100 ||
        (this.consumerHasDescriptionField && !this.descriptionVideoUpload)
    },
    uploadVideoForm () {
      return {
        titleVideoUpload: this.titleVideoUpload,
        uploadVideoAuthor: this.uploadVideoAuthor,
        // descriptionVideoUpload: this.descriptionVideoUpload,
        typeVideoUpload: this.typeVideoUpload
      }
    }
  },

  methods: {
    ...mapActions(['syncFtp', 'syncImagesFtp']),
    // Debounced author lookup for the "filter by user" autocomplete so we fire
    // one request per typing pause instead of one per keystroke. The previous
    // in-flight guard also silently dropped keystrokes typed while a request
    // was pending; debouncing keeps only the latest value, which is correct.
    fetchFilterAuthors: debounce(function (val) {
      this.isLoadingAuthors = true
      let headers = auth.getAuthHeader()
      http.get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true)
        .then(res => {
          this.filtersAuthors = res
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoadingAuthors = false))
    }, 400),
    videoUploadTypeName (value) {
      const keys = {
        sport: 'lmr_category.sports',
        general: 'lmr_category.infos_locales',
        magazine: 'lmr_category.magazine',
        faits_divers: 'lmr_category.faits_divers'
      }
      return this.$t(keys[value])
    },
    setupInterval () {
      clearInterval(this.timer)
      this.timer = setInterval(this.updateRecords.bind(this), 30000)
    },
    handleRecordDelete (record, recordType) {
      // handle record delete confirmation, submit to backend and reload records list
      RecordRepository.deleteRecord(this.markerId, record).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleRecordRestore (record, recordType) {
      RecordRepository.restoreRecord(this.markerId, record).then(() => {
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleTagsSelected (tags) {
      this.recordFilters.tags = tags
      this.fetchRecords()
    },
    handleLmrCitySelected (cities) {
      this.recordFilters.lmr_cities = cities
      this.fetchRecords()
    },
    handleEditorConsumerSelected (consumers) {
      this.recordFilters.editor_consumers = consumers
      this.fetchRecords()
    },
    fetchRecordsFromRepository (recordType, page, tabName) {
      return RecordRepository.fetchMarkerRecords(
        this.markerId,
        page || this.currentPage,
        this.pageSize,
        this.recordOrdering,
        this.department,
        this.recordFilters,
        recordType || this.recordType,
        tabName || this.activeTabName,
      )
    },
    updateRecords () {
      const route = this.$route.path
      const page = this.showVideos ? this.currentPage : 1
      const tabName = this.showVideos ? this.activeTabName : 'new'
      // this.itemsOfOrdering()
      this.fetchRecordsFromRepository('VIDEO', page, tabName).then((records) => {
        if (
          this.$route.path !== route ||
          page !== (this.showVideos ? this.currentPage : 1)
        ) return // skip stale results

        var newVideosCount = records.filter(record => {
          if (record.transcoding_complete_date) {
            var timestamp = new Date(record.transcoding_complete_date).getTime()
            return timestamp > this.pageLoadDate
          }
        }).length

        if (this.showImages) {
          if (newVideosCount) this.newVideosCount = newVideosCount
          return
        }

        // further code goes for showVideos == true
        if (this.records.length === 0) {
          // if we had no videos previously, just load up the new one(s)
          this.records = records
          if (this.activeTabIndex === this.recordTabs.new) {
            this.newTabRecordsCount = records.count
            this.setPageLoadDate()
          }
          this.$refs.tagsFilter.fetchTags()
          return
        }

        if (newVideosCount > 0) {
          // store the new videos count to show notification about new vids
          this.newVideosCount = newVideosCount
          // update records state but don't update records list
          this.records.forEach((record, index) => {
            const freshRecord = records.find(rec => rec.id === record.id)
            if (!freshRecord) return // record left this page/tab — keep the one already on screen
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = record.digiteka_id
            this.records[index] = freshRecord
            this.records = this.records.slice() // activate reactivity system
          })
        } else {
          // update records state
          // this.records = records
          this.records.forEach((record, index) => {
            const freshRecord = records.find(rec => rec.id === record.id)
            if (!freshRecord) return // record left this page/tab — keep the one already on screen
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = record.digiteka_id
            this.records[index] = freshRecord
          })
          if (this.activeTabIndex === this.recordTabs.new) {
            this.newTabRecordsCount = records.count
          }
        }
      }).catch(error => {
        // background refresh on a 30s timer — swallow the error so a stale
        // page/route race never crashes the records list (it used to throw an
        // unhandled rejection and freeze the list mid-update). The next tick or
        // a manual fetchRecords() recovers; logged for debugging only.
        console.warn('records refresh poll failed', error)
      })
    },
    swapInNewRecords () {
      if (this.showImages) {
        this.$router.push('/videos/new')
      } else if (this.activeTabIndex !== this.recordTabs.new) {
        this.activeTabIndex = 0
      } else {
        this.fetchRecords()
      }
      this.newVideosCount = 0
    },
    fetchRecords () {
      this.loading = true
      const route = this.$route.path
      const page = this.currentPage

      this.fetchRecordsFromRepository().then((records) => {
        if (this.$route.path !== route || this.currentPage !== page) return // skip stale results
        this.records = records
        if (this.activeTabIndex === this.recordTabs.new) {
          this.newTabRecordsCount = records.count
          if (this.showVideos && this.currentPage === 1) {
            // update pageLoadDate every time we update videos on first page
            this.setPageLoadDate()
          }
        }
        this.loading = false
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
      if (this.activeTabIndex === this.recordTabs.approved) {
        this.itemsOrdering = [
          {text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date'},
          {text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date'},
          {text: this.$t('ordering.by_approve_date_new_old'), value: '-approved_date'},
          {text: this.$t('ordering.by_approve_date_old_new'), value: 'approved_date'},
        ]
      } else {
        this.itemsOrdering = [
          {text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date'},
          {text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date'},
        ]
      }
    },
    // fetchRelatedRecords () {
    //   if (!this.markerId) return
    //   RecordRepository.fetchMarkerRelatedRecords(this.markerId, this.activeTabName)
    //     .then((records) => { this.relatedRecords = records })
    // },
    // fetchRecordsDiversity () {
    //   if (!this.markerId) return
    //   RecordRepository.fetchMarkerRecordsDiversityTree(this.markerId)
    //     .then((response) => { this.diversityTree = response.tree })
    // },
    markRecordRelevance (record, relevance, recordType) {
      const r = this.getRecords(recordType).find((r) => { return r.id === record.id })
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance
      }
      RecordRepository.patchRecordRelevance(this.markerId, record, relevance)
      .catch((error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    getRecords (recordType) {
      const typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      }
      return typeMapping[recordType]
    },
    showRecordDetails (record) {
      this.selectedRecord = record
    },
    recordClicked (record) {
      if (this.approveMode || this.mergeMode || this.downloadMode) {
        // add or remove record from selected
        if (!this.selectedRecords.some(rec => rec.id === record.id)) {
          this.selectedRecords.push(record)
        } else {
          this.selectedRecords = this.selectedRecords.filter(rec => rec.id !== record.id)
        }
      } else {
        this.showRecordDetails(record)
      }
    },
    isChoosingMode () {
      return this.approveMode || this.mergeMode || this.downloadMode
    },
    toggleApproveMode () {
      this.selectedRecords = []
      this.approveMode = !this.approveMode
      this.mergeMode = false
      this.downloadMode = false
      if (!this.approveMode) document.activeElement.blur()
    },
    toggleMergeMode () {
      this.selectedRecords = []
      this.mergeMode = !this.mergeMode
      this.approveMode = false
      this.downloadMode = false
      this.showPremergeModal = false
      this.mergeData.approve = false
      this.mergeData.title = ''
      this.mergeData.description = ''
      if (!this.mergeMode) document.activeElement.blur()
    },
    // toggleDownloadMode () {
    //   this.selectedRecords = []
    //   this.approveMode = false
    //   this.mergeMode = false
    //   this.downloadMode = !this.downloadMode
    //   if (!this.downloadMode) document.activeElement.blur()
    // },
    rejectRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.rejectRecords(ids).then(() => {
        this.toggleApproveMode()
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    approveRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.approveRecords(ids).then(() => {
        this.toggleApproveMode()
        if (this.$root.$children[0].$data.clientId === 'digiteka') {
          this.$store.commit('snackbar/show', {
            message: this.$t('approve_msg'),
            color: '#0fd3bd',
            href: 'https://www.ultimedia.com/central/video/list/',
            timeout: 30000,
          })
        }
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    async downloadRecord (record) {
      const FileSaver = require('file-saver')
      const res = await fetch(record.play_link)
      const blob = await res.blob()
      FileSaver.saveAs(blob, record.verbose_filename)
      RecordRepository.setDownloaded(record.name)
    },
    downloadRecords () {
      this.selectedRecords.forEach((value, index) => this.downloadRecord(value))
      this.toggleApproveMode()
    },
    async downloadRecordsZip () {
      const ids = this.selectedRecords.map(rec => rec.id)
      if (ids.length === 1) {
        this.downloadRecords()
      } else {
        RecordRepository.downloadRecordsZip(ids).then(data => {
          this.toggleApproveMode()
          if (data.download_url) {
            const FileSaver = require('file-saver')
            FileSaver.saveAs(data.download_url, 'images.zip')
          } else {
            alert(this.$t('records.download_zip_error'))
          }
        })
      }
    },
    setMergeRecordTitle (approve) {
      const concat = this.concatenateSelectedRecordsWithSpacesField

      if (this.consumerHasDescriptionField) {
        this.mergeData.title = concat('title')
        this.mergeData.description = concat('description')
      } else {
        this.mergeData.title = concat('title')
      }
      this.mergeData.approve = approve
      this.showPremergeModal = true
    },
    mergeRecords (approve) {
      let uploadVideoFormHasErrors = false
      const data = Object.assign({}, this.mergeData)
      if (data.title > 100) {
        uploadVideoFormHasErrors = true
      }

      if (uploadVideoFormHasErrors === false) {
        const ids = this.selectedRecords.map(rec => rec.id)
        RecordRepository.mergeRecords(ids, this.mergeData).then(() => {
          this.toggleMergeMode()
          if (data.approve) {
            if (this.$root.$children[0].$data.clientId !== 'digiteka') {
              this.$store.commit('snackbar/show', {
                message: this.$t('merge_and_approve_msg_pm'),
                color: 'green',
                timeout: 30000,
              })
            } else {
              this.$store.commit('snackbar/show', {
                message: this.$t('merge_and_approve_msg_iframe_digiteka'),
                color: '#0fd3bd',
                href: 'https://www.ultimedia.com/central/video/list/',
                timeout: 30000,
              })
            }
          } else {
            if (this.$root.$children[0].$data.clientId !== 'digiteka') {
              this.$store.commit('snackbar/show', {
                message: this.$t('merge_msg'),
                color: 'green',
                timeout: 30000,
              })
            } else {
              this.$store.commit('snackbar/show', {
                message: this.$t('merge_msg'),
                color: '#0fd3bd',
                timeout: 30000,
              })
            }
          }
          this.mergeRecordTimeout = setTimeout(() => this.fetchRecords('VIDEO'), 2000)
        }, error => {
          events.emit('error', error, '', {modal: false})
          this.$store.commit('snackbar/show', {
            message: error.message,
            color: 'error',
            timeout: 4,
          })
        })
      }
    },
    restoreRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.restoreRecords(ids).then(() => {
        this.toggleApproveMode()
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    setCutIcon (record) {
      const rec = this.records.find(r => r.id === record.id)
      if (rec) {
        rec.process_statuses.push({
          process: 'cut', status: 'running'
        })
      }
    },
    updateRecordProcessStatus () {
      RecordRepository.getRecordsStatuses(this.records.map(record => record.id))
        .then(resp => {
          this.processStatusPollFailed = false
          for (let record of this.records) {
            const statuses = resp.filter(item => item.record === record.id)
            // only replace when the poll actually returned statuses for this
            // record — a transiently empty/partial response must not wipe an
            // already-earned green checkmark.
            // Trade-off: if the backend legitimately drops ALL statuses for a
            // record (process reset/cancelled server-side), this won't reflect
            // it until the next non-empty poll or a full fetchRecords().
            if (statuses.length > 0) {
              record.process_statuses = statuses
            }
          }
        })
        .catch(error => {
          // this runs on a 10s timer: stay silent (no blocking modal) and warn
          // the user only once per failure streak, so a backend outage doesn't
          // spam them. processStatusPollFailed resets above on the next success.
          if (!this.processStatusPollFailed) {
            this.processStatusPollFailed = true
            console.warn('process-status poll failed', error)
            this.$store.commit('snackbar/show', {
              message: this.$t('error.status_poll'),
              color: 'error',
              timeout: 6000,
            })
          }
        })
    },
    // Map the URL's :tab param (new/approved/deleted) to its tab index,
    // defaulting to the first tab when the param is absent or unknown.
    tabIndexFromRoute () {
      const tabEntries = Object.entries(this.recordTabs)
      const tab = tabEntries.find(([name]) => name === this.$route.params.tab) || tabEntries[0]
      return tab[1]
    },
    setRecordTabRoute () {
      if (this.$route.params.tab !== this.activeTabName) {
        this.$router.replace({
          name: this.$route.name,
          params: {tab: this.activeTabName}
        })
      }
    },
    setPageLoadDate () {
      this.pageLoadDate = new Date().getTime()
    },
    concatenateSelectedRecordsWithSpacesField (fieldName) {
      return this.selectedRecords
                 .map((record) => record[fieldName])
                 .join(' ; ')
    },
    concatenateSelectedRecordsField (fieldName) {
      return this.selectedRecords.reduce((text, record, index) => {
        if (index === 1) { // FIXME: too complicated
          if (text[fieldName] && record[fieldName]) {
            return text[fieldName] + '; ' + record[fieldName]
          } else {
            return text[fieldName] || record[fieldName]
          }
        } else if (text && record[fieldName]) {
          return text + '; ' + record[fieldName]
        } else {
          return record[fieldName]
        }
      })
    },
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.dragging = false
        return
      }
      this.createFile(files[0])
    },
    createFile (file) {
      // some browsers/OS report an empty file.type for valid videos, which
      // used to randomly reject good files; fall back to the extension then.
      const looksLikeVideo = file.type
        ? /video.*/.test(file.type)
        : /\.(mp4|mov|m4v|webm|avi|mkv|ogv|3gp|wmv|flv)$/i.test(file.name)
      if (!looksLikeVideo) {
        alert(this.$t('upload_video.please_select_video_file'))
        this.dragging = false
        return
      }
      if (file.size > 500000000) {
        alert(this.$t('upload_video.please_check_file'))
        this.dragging = false
        return
      }
      this.uploadingVideoFile = file
      this.dragging = false
    },
    removeFile () {
      this.uploadingVideoFile = ''
    },
    async uploadData () {
      this.uploadVideoFormHasErrors = false
      if (!this.uploadingVideoFile) {
        this.uploadVideoFormHasErrors = true
      }
      Object.keys(this.uploadVideoForm).forEach(f => {
        if (!this.uploadVideoForm[f]) this.uploadVideoFormHasErrors = true
        this.$refs[f].validate(true)
      })

      if (!this.uploadVideoFormHasErrors) {
        let headers = auth.getAuthHeader()
        let uploadUrlData = await http.post(
          '/record/raw/upload/',
          headers,
          {
            comment: this.descriptionVideoUpload,
            record_type: 'VIDEO',
            address: '',
            user_id: this.uploadVideoAuthor.pk
          }
        )
        const uploadDone = rawRecordId => {
          let url = '/record/raw/upload/' + rawRecordId + '/done/'
          headers['Content-Type'] = 'application/json'
          console.log(this.recommendedPublicationDate)
          return http.post(url, headers,
            {
              'title': this.titleVideoUpload,
              'description': this.descriptionVideoUpload,
              'lmr_category': this.typeVideoUpload,
              'user_id': this.uploadVideoAuthor.pk,
              'autoapprove': false,
              'recommended_publication_date': this.recommendedPublicationDate,
              'comment_from_author': this.commentFromAuthor
            }
          )
        }
        // Finalize with retry. The backend `done` endpoint is not strictly
        // idempotent, but it IS duplicate-safe: once a raw record is completed it
        // returns 409 ("already completed" / "record already exists") instead of
        // creating a second record. So a finalize that failed *transiently*
        // (network / timeout / 5xx — common with a flaky backend) can be retried
        // safely WITHOUT re-uploading the file (it already lives in S3).
        //   201           -> finalized, success
        //   409           -> record already exists server-side (e.g. a previous
        //                    attempt succeeded but its response was lost) ->
        //                    treat as SUCCESS, not an error
        //   5xx / no resp -> transient -> back off and retry
        //   4xx (e.g 400) -> permanent (bad data) -> give up immediately
        const finalizeWithRetry = async (rawRecordId, attempts = 3) => {
          for (let i = 0; i < attempts; i++) {
            try {
              await uploadDone(rawRecordId)
              return
            } catch (err) {
              const status = err.response && err.response.status
              if (status === 409) return // already finalized server-side -> success
              const transient = !err.response || status >= 500
              if (!transient || i === attempts - 1) throw err
              // wait before retrying (1.5s, then 3s) to let a hiccuping backend recover
              await new Promise(resolve => setTimeout(resolve, 1500 * (i + 1)))
            }
          }
        }
        var xhr = new XMLHttpRequest()
        var ref = this
        // --- Upload stall watchdog ------------------------------------------
        // The file is PUT straight to S3 through this XHR, which has no timeout
        // of its own. On a frozen or dropped connection the request would hang
        // indefinitely and leave the modal stuck on the progress bar.
        //
        // We intentionally do NOT use a *total* deadline (xhr.timeout): a valid
        // upload can legitimately take minutes (files up to 500 MB on a slow
        // link), so a fixed total timeout would kill good uploads. Instead we
        // watch for a *stall* — no upload progress for UPLOAD_STALL_MS — which
        // distinguishes "slow but advancing" (fine) from "frozen" (abort).
        //
        // Lifecycle: armStall() starts the countdown right after send(); each
        // progress event re-arms it (resets the countdown); onload/onerror
        // clears it once the request settles. If the timer ever fires, the
        // transfer is considered dead and aborted.
        const UPLOAD_STALL_MS = 60000
        var stallTimer = null
        const clearStall = () => {
          if (stallTimer) {
            clearTimeout(stallTimer)
            stallTimer = null
          }
        }
        const armStall = () => {
          clearStall() // never keep two timers; each call restarts the countdown
          stallTimer = setTimeout(() => {
            // No bytes moved for UPLOAD_STALL_MS → treat the upload as dead.
            // NB: xhr.abort() fires the `abort` event, NOT onload/onerror, so we
            // reset the UI and notify the user here rather than in the handler.
            xhr.abort()
            ref.videoFileUploading = false
            ref.bufferVideoUploading = 0
            ref.$store.commit('snackbar/show', {
              message: ref.$t('upload_video.upload_timeout'),
              color: 'error',
              timeout: 6000
            })
          }, UPLOAD_STALL_MS)
        }
        xhr.upload.onprogress = event => {
          this.bufferVideoUploading = parseInt((event.loaded / event.total) * 100)
          armStall() // bytes moved → reset the stall countdown
        }
        xhr.onload = xhr.onerror = async function () {
          // request settled (success or HTTP error) → disarm the watchdog first,
          // so it can't false-fire during the async finalize (uploadDone) below
          clearStall()
          if (this.status !== 200) {
            // PUT to S3 failed — surface it instead of failing silently
            ref.videoFileUploading = false
            ref.bufferVideoUploading = 0
            console.log('upload error ' + this.status)
            ref.$store.commit('snackbar/show', {
              message: ref.$t('upload_video.upload_error'),
              color: 'error',
              timeout: 6000
            })
            return
          }
          // PUT succeeded; finalize the record on the backend and only declare
          // success once 'done' actually resolves (the file lives in S3 until then)
          try {
            await finalizeWithRetry(uploadUrlData.id)
            ref.dialog = false
            ref.uploadingVideoFile = ''
            ref.dragging = false
            ref.titleVideoUpload = ''
            ref.authorVideoUpload = ''
            ref.descriptionVideoUpload = ''
            ref.commentFromAuthor = ''
            ref.recommendedPublicationDate = ''
            ref.typeVideoUpload = 'sport'
            ref.uploadVideoFormHasErrors = false
            ref.fetchRecords('VIDEO')
          } catch (e) {
            // file is uploaded but finalize failed (e.g. backend down); keep the
            // form so the user can retry instead of leaving a silent orphan
            console.log('finalize error', e)
            ref.$store.commit('snackbar/show', {
              message: ref.$t('upload_video.upload_error'),
              color: 'error',
              timeout: 6000
            })
          } finally {
            ref.videoFileUploading = false
            ref.bufferVideoUploading = 0
          }
        }

        xhr.open('PUT', uploadUrlData.upload_link, true)
        xhr.setRequestHeader('Accept', '*/*')
        // DO NOT change this Content-Type. The backend signs the presigned
        // upload_link with Content-Type 'video/mp4', so the PUT must send the
        // exact same value or S3 rejects it with 403 SignatureDoesNotMatch.
        // Deriving it from the file's real type would break every non-mp4 upload.
        xhr.setRequestHeader('Content-Type', 'video/mp4')
        xhr.send(this.uploadingVideoFile)
        armStall() // start the stall watchdog once the transfer is underway
        this.videoFileUploading = true
      }
    }
  }, // methods

  beforeDestroy: function () {
    clearInterval(this.timer)
    clearInterval(this.processStatusInterval)
    clearTimeout(this.mergeRecordTimeout)
  },

  watch: {
    $route (to, from) {
      // Keep the active tab in sync with the URL's :tab param. The component is
      // reused for /videos/:tab and /images/:tab, so navigating between tabs of
      // the same record type (e.g. the header "Videos" link from
      // /videos/approved to /videos/new) only changes the param, not the route
      // name — without this the tab UI stayed on the previous tab.
      this.activeTabIndex = this.tabIndexFromRoute()
      if (to.name !== from.name) {
        // switching record type (videos <-> images)
        this.newTabRecordsCount = 0
      }
      this.records = []
      this.currentPage = 1
      this.mergeMode = false
      this.approveMode = false
      this.downloadMode = false
      this.selectedRecords = []
      this.fetchRecords()
      // this.fetchRelatedRecords()
    },
    activeTabIndex (newVal, oldVal) {
      this.recordOrdering = ''
      clearTimeout(this.mergeRecordTimeout)
      this.setRecordTabRoute()
    },
    searchFilteredUser (val) {
      // The field still shows the selected user's label: keep the selection.
      if (this.recordFilters.user && val === this.recordFilters.user.autocomplete_full_name) {
        this.filtersAuthors = [this.recordFilters.user]
        return
      }
      // Typing invalidates any previous selection.
      this.recordFilters.user = null
      if (!val) {
        this.filtersAuthors = []
        return
      }
      // Debounced lookup: one request per typing pause, not per keystroke.
      this.fetchFilterAuthors(val)
    },
    search (val) {
      if (this.uploadVideoAuthor && val === this.uploadVideoAuthor.autocomplete_full_name) {
        this.entriesAuthors = [this.uploadVideoAuthor]
        return
      }
      this.uploadVideoAuthor = null
      // Items have already been loaded
      // this.uploadVideoAuthor = null
      if (!val) {
        this.entriesAuthors = []
        this.uploadVideoAuthor = null
        return
      }

      // Items have already been requested
      if (this.isLoadingAuthors) return
      this.isLoadingAuthors = true
      let headers = auth.getAuthHeader()
      // Lazily load input items
      http.get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true)
        .then(res => {
          this.entriesAuthors = res
        })
        .catch(err => {
          console.log(err)
          console.log('----', err)
        })
        .finally(() => (this.isLoadingAuthors = false))
    }
  }, // watch
}
</script>

<style lang="sass">
.v-tabs__item
  .badge
    margin-left: 5px
.records
  .loading-indicator
    margin-top: 20px
// Refresh indicator: while a filter/ordering change refetches over an existing
// list, dim the current list and float a centered spinner over it. The list is
// not emptied, so the empty-state spinner won't show.
.records-list-wrap
  position: relative
.records--refreshing
  opacity: 0.4
  pointer-events: none
  transition: opacity 0.15s ease
.records-refresh-overlay
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  align-items: flex-start
  justify-content: center
  padding-top: 60px
  pointer-events: none
.order_list
  .v-input__control
    display: flex
    flex-direction: column
    height: auto
    flex-grow: 1
    flex-wrap: wrap
    width: 100%
    margin: 0 15px
.order_list.v-text-field--outline > .v-input__control > .v-input__slot
  border: 1px solid #e8e8e8
.order_list.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover
  border: 1px solid #e8e8e8
.order_list.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot
  min-height: 42px
  padding-right: 8px
.order_list.v-text-field.v-text-field--enclosed .v-input__append-inner
  margin-top: 8px
#download-mode-btn
  opacity: 0.5
</style>

<style lang="css">
.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #ff2d55;
}

.dropZone:hover .dropZone-title {
  color: #ff2d55;
  font-weight: bold;
}

.dropZone-info {
  /*color: #A8A8A8;*/
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
  font-weight: bold;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*color: #5C5C5C;*/
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>
